export default {
  languages: [
    {
      code: "en",
      dir: "ltr",
      name: "English",
    },
    {
      code: "ar",
      dir: "rtl",
      name: "Arabic",
    },
  ],

  currency: {
    locale: "ar-SA",
    code: "SAR",
  },

  labels: {
    details: {
      en: "Details",
      ar: "التفاصيل",
    },

    dwellingLabel: {
      en: "Type",
      ar: "النموذج",
    },
    dwellingSize: {
      en: "Build Up Area",
      ar: "مسطح البناء",
    },
    dwellingBuilder: {
      en: "Developer",
      ar: "المطور​",
    },
    dwellingDesign: {
      en: "Design",
      ar: "تصميم البناء",
    },
    dwellingFeatures: {
      en: "Features",
      ar: "المواصفات​",
    },
    dwellingDescription: {
      en: "description",
      ar: "وصف",
    },
    dwellingPrice: {
      en: "Price",
      ar: "السعر",
    },
    dwellingBeds: {
      en: "Rooms",
      ar: "غرف",
    },
    dwellingBaths: {
      en: "Baths",
      ar: "دورات مياه",
    },
    dwellingCars: {
      en: "Parking",
      ar: "موقف",
    },
    propertyLabel: {
      en: "Unit No.",
      ar: "رقم الوحدة",
    },
    propertySize: {
      en: "Land Area",
      ar: "مساحة الأرض",
    },
    propertyPrice: {
      en: "Price",
      ar: "السعر",
    },

    description: {
      en: "Description",
      ar: "وصف",
    },
    exploreCommunities: {
      en: "Explore Communities",
      ar: "استكشاف المجتمعات",
    },
    features: {
      en: "Features",
      ar: "المواصفات​",
    },
    openingHours: {
      en: "Opening Hours",
      ar: "ساعات العمل",
    },
    backButton: {
      en: "Back",
      ar: "سابق",
    },
    favouritesButton: {
      en: "View Favourites",
      ar: "عرض المفضلة",
    },
    addToFavourites: {
      en: "Add to Favourites",
      ar: "أضف إلى المفضلة",
    },
    available: {
      en: "Available",
      ar: "متاح",
    },
    onHold: {
      en: "On Hold",
      ar: "لم يطلق",
    },
    sold: {
      en: "Sold",
      ar: "مباع",
    },
    viewLabel: {
      en: "Aspect",
      ar: "",
    },
  },

  minimapPositionPage: "bottom",

  general: {
    showHomeButton: true,
    showFavourites: true,
  },
  filter: {
    enabled: false,
  },
};
